import { IMicroConfiguration } from '../types/configuration';
import { TMicroDefinition } from '../types/configuration';
import { Micro } from '../core/micro';

import f1 from'../../../pip/library/pi-f1/pi-f1.js';

export class MicroBuilder {
  /**
   * accept any required object and convert to a standard Micro
   */
  static build(MicroType: TMicroDefinition): Promise<Micro<IMicroConfiguration>> {
    const micro =
      MicroType instanceof Micro
        ? MicroType
        : f1.is.record(MicroType)
        ? new Micro().proxyConfiguration(this.readAPI(MicroType))
        : f1.is.class(MicroType)
        ? new MicroType()
        : new Micro();

    const microDelegate = f1.is.in('$delegate', micro) && f1.is.function(micro.$delegate) ? micro.$delegate() : micro;

    return f1.done(microDelegate);
  }

  static readAPI(o: Record<string, unknown>): Record<string, unknown> {
    return (o.data ? o.data : o) as Record<string, unknown>;
  }
}
